export const mergeCategoryData = (paginatedData, allData) => {
    if (!allData || allData.length === 0) return paginatedData;

    // Use all categories data for the sidebar
    const mergedData = [...allData];

    return mergedData;
};